import React, { useImperativeHandle, useState } from 'react';
import { HoursInput, MinutesInput, Separator, TimepickerLabel, TimepickerWrapper } from '@@Components/Timepicker/styled';
export const Timepicker = React.forwardRef((props, ref) => {
    const { maxHour, maxMinute, onChange, onBlur, disabled, label, required, error, } = props;
    const [focused, setFocused] = useState(false);
    const [hour, setHour] = useState();
    const [minute, setMinute] = useState();
    const validateKeyUp = (event) => {
        // @ts-ignore
        const { value } = event.target;
        const keyCode = event.keyCode;
        // Allow only two-digit values, allow backspace and tab
        if (value && value.length >= 2 && keyCode !== 8 && keyCode !== 9) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    const setHourTime = (value) => {
        if (Number(value) < 24 && (maxHour ? Number(value) <= maxHour : true)) {
            setHour(value);
            onChange && onChange(`${value}:${minute}`);
        }
    };
    const setMinuteTime = (value) => {
        if (Number(value) < 60 && (maxMinute ? Number(value) <= maxMinute : true)) {
            setMinute(value);
            onChange && onChange(`${hour}:${value}`);
        }
    };
    const handleBlur = () => {
        let tempHour = hour;
        let tempMinute = minute;
        if (!hour)
            tempHour = '00';
        if (!minute)
            tempMinute = '00';
        onBlur && onBlur();
        onChange && onChange(`${tempHour}:${tempMinute}`);
        setHour(('0' + tempHour).substr(-2));
        setMinute(('0' + tempMinute).substr(-2));
        setFocused(false);
    };
    if (ref) {
        useImperativeHandle(ref, () => ({
            getValue: () => `${hour}:${minute}`
        }), [hour, minute]);
    }
    return React.createElement(TimepickerWrapper, { disabled: disabled, focused: focused, error: !!error },
        label && (React.createElement(TimepickerLabel, { disabled: disabled }, `${required ? '*' : ''}${label}`)),
        React.createElement(HoursInput, { placeholder: "00", autoComplete: "off", type: "number", pattern: "[0-9]{1,2}", value: hour, disabled: disabled, onBlur: handleBlur, onFocus: () => setFocused(true), onKeyDown: validateKeyUp, onChange: (e) => setHourTime(e.target.value) }),
        React.createElement(Separator, null, ":"),
        React.createElement(MinutesInput, { placeholder: "00", autoComplete: "off", type: "number", pattern: "[0-9]{1,2}", value: minute, disabled: disabled, onBlur: handleBlur, onFocus: () => setFocused(true), onKeyDown: validateKeyUp, onChange: (e) => setMinuteTime(e.target.value) }));
});
